import { useSearchParams } from "react-router-dom"
import { Helmet } from "react-helmet-async";
import { Header, Footer } from "../Components/MaitlandWebsite";
import { useState } from "react";
import { Text, Center, Spinner, Button } from "@chakra-ui/react"

// Default Base URL
const baseUrl = window.location.origin === "https://forms.maitland.nsw.gov.au" ? 
    process.env.REACT_APP_APIURL : process.env.REACT_APP_NONPRODAPIURL;

export default function PropertyCertificatesPaid() {

    const [searchParams] = useSearchParams();
    const [isLoading, setIsLoading] = useState(true);
    const [emailAddress, setEmailAddress] = useState(null);
    const reference = searchParams.get("reference");
    const wassuccessful = searchParams.get("successful");

    function retreiveEmailByInvoice() {        
        // Retreive Access Token for payment.
        fetch(baseUrl + "property/certificates-by-invoice?invoiceNumber=" + reference, {
            method: "GET"
        })
        .then(response => response.json())
        .then(response => {           
            if(response.length !== 0) {  
                setEmailAddress(response[0].emailAddress);
                updatePropertyCertificatesData(response[0].emailAddress, reference);
                setIsLoading(false);
            } else {
                setEmailAddress("noInvoice");
                setIsLoading(false);
            }
        })
        .catch(error => console.log(error));
    }

    function updatePropertyCertificatesData(emailAddress, invoiceNumber) {
        // Update database and send email through to customer.
        var parameters = "?emailAddress=" + emailAddress + "&invoiceNumber=" + invoiceNumber;

        fetch(baseUrl + "property/certificates" + parameters, {
            method: "PUT",
            headers: {
                'Content-Type': 'application/json'
            }
        })
        .then(response => response.json())
        .then(response => {           
            console.log(response); 
        })
        .catch(error => console.log(error));
    }

    if (wassuccessful === "true") {
        if (!emailAddress) {
            retreiveEmailByInvoice();
        }
    }

    return (
        <>
            <Helmet>
                <meta http-equiv="Content-Security-Policy" content={`default-src 'self'; style-src 'self' https://maitlandapi.wpengine.com/mccds/ 'unsafe-inline'; 
                    connect-src 'self' ${baseUrl}property/`} />
            </Helmet>  
            <Header heading="Property certificate form" />
            {wassuccessful === "true" ? <>
                {isLoading && <>            
                    <Center>
                        <Spinner size="lg" />
                    </Center>
                    <Center>
                        <Text fontSize="2xl">Please Wait</Text>
                    </Center>
                </>}
                {!isLoading && <>
                    {emailAddress === "noInvoice" ?
                    <>
                        <Center>
                            <Text fontSize="xl">Unable to find invoice number for Property certificate</Text>
                        </Center>
                        <Center>
                            <Text fontSize="xl">If you didn't receive your email, please call our customer experience team on 4934 9700.</Text>
                        </Center><br />
                    </> :
                    <>
                        <Center>
                            <Text fontSize="2xl" fontWeight="bold">Success</Text>
                        </Center><br />
                        <Center>
                            <Text fontSize="xl">Successfully paid for Property certificate</Text>
                        </Center><br />
                        <Center>
                            <Text fontSize="2xl" fontWeight="bold">Invoice reference number</Text>
                        </Center><br />
                        <Center>
                            <Text fontSize="xl">{reference}</Text>
                        </Center><br />
                        <Center>
                            <Text fontSize="xl">A copy of your invoice has been sent to the email address: {emailAddress}</Text>
                        </Center><br />
                    </>}
                    <Center>
                        <Button onClick={() => window.location.href = "https://www.maitland.nsw.gov.au/"} size="lg" variant="Primary">Return Home</Button>
                    </Center>
                </>}
            </> : <>
                <Center>
                    <Text fontSize="2xl" fontWeight="bold">Unsuccessful</Text>
                </Center><br />
                <Center>
                    <Text fontSize="xl">It appears there was an issue with the transaction, please try again.</Text>
                </Center><br />
                <Center>
                    <Text fontSize="xl">If the issue continues please contact your financial institution.</Text>
                </Center><br />
                <Center>
                    <Button onClick={() => window.location.href = "https://www.maitland.nsw.gov.au/services/planning-development/property-certificates/property-certificates-order-form"} size="lg" variant="Primary">Property certificate form</Button>
                </Center>
            </>}
            <Footer />
        </>
    )
}